import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import jwtEncode from "jwt-encode";
import FormController from "./FormController/formController";
import Login from "./Authentication/Login";
import BuyNow from "./Authentication/Buynow";
import SimulanisLogin from "./Authentication/SimulanisLogin";
import LeftNavBar from "./Navbar/LeftNavbar";
import TopNavBar from "./Navbar/TopNavBar";
import DashboardController from "./FormController/dashboardController";
import CallingChannel from "./FormController/VideoChat/CallingChannel";
import BottomNavigationBar from "./common/BottomNavigationBar";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/icons.css";
import "./assets/css/style.css";
import "./assets/css/style_custom.css";
import "./assets/css/lightdarkmode.css";
import "./assets/css/filter.scss";
import {
  jwt,
  ud,
  SERVER_IP,
  PORT,
  changeUserInfo,
  Communication_obj,
  auth_response_flow,
  UpdateLicense,
  redirectUrl,
  applicationId,
  UNO_URL,
} from "./Server";
import { SOCKET, UpdateSocket } from "./SocketData";
import AcessDenied from "./FormController/SplashPage/AcessDenied";
import Authloading from "./FormController/SplashPage/authLoading";
import axios from "axios";
import Projects from "./FormController/Projects/project";
import UserState from "./context/UserState";
import { Videocall, Audiocall } from "./FormController/VideoChat/Call";
import swal from "sweetalert";
import FullScreenLoader from "./FullScreenLoader/fullScreenLoader";
// import socketIo from "socket.io-client";
import NewCall from "./FormController/Iframe/NewCall";
import AppRoutes from "./AppRoutes";
import Sidebar from "./Navbar/Sidebar";
import { isMobile } from "./common/MobileView";
import { connect } from "react-redux";
import { saveMobileView, saveUserDetails, saveSubGroups } from "./redux/actions/User.action";
import HeaderMobile from "./common/HeaderMobile";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
var socket;
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      to_calling_obj: undefined,
      callChannel: Communication_obj,
      auth_wait: false,
      liveusers: [],
      loading: true,
      loader: true,
    };
  }
  getUserDetailsFromUno = async (userToken) => {
    // const token = localStorage.getItem("unoToken");
    try {
      let { data } = await axios.get(`${UNO_URL}/api/user/me`, {
        headers: {
          authorization: `Bearers ${userToken}`,
        },
      });
      this.props.saveUserDetails(data?.data);

      const groupId = data?.data?.user?.group?.uuid;

      let subGroupsDataHierarchyPromise = axios.get(`${UNO_URL}/api/group/all/children/hierarchy/${groupId}`, { headers: { authorization: `Bearers ${userToken}` } });

      let subGroupsDataListPromise = axios.get(`${UNO_URL}/api/group/all/children/list/${groupId}`, { headers: { authorization: `Bearers ${userToken}` } });

      let [subGroupsDataHierarchy, subGroupsDataList] = await Promise.all([subGroupsDataHierarchyPromise, subGroupsDataListPromise]);

      const combinedSubGroups = {
        subGroupsDataHierarchy: subGroupsDataHierarchy?.data?.data || [],
        subGroupsDataList: subGroupsDataList?.data?.data || [],
      };

      this.props.saveSubGroups(combinedSubGroups);

    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  getLicenseDetails = () => {
    let _this = this;
    if (jwt == undefined || jwt == "") {
      this.setState({ auth_wait: true });
      this.authanticate();
    }
    if (jwt) {
      if (ud.c_id != 0) {
        UpdateLicense();
      }
    }

    if (this.state.callChannel) {
      if (jwt) {
        if (ud) {
          if (ud.usertype === 3) {
            // socket = socketIo(SERVER_IP, { transports: ["websocket"] });
            socket = require("socket.io-client")(`${SERVER_IP}`);

            _this.emit_I_AM_ONLINE();

            socket.on("reconnect", function () {
              _this.emit_I_AM_ONLINE();
            });

            socket.on("live_users_list", function (data) {
              _this.setState({ liveusers: data.liveusers });
            });

            UpdateSocket(socket);
            this.setState({ socket: socket });
          }
        }
      }
    }
  };

  getAgainUnoUserToken = async () => {
    const storageConfig = localStorage.getItem("configuration");
    const configData = JSON.parse(storageConfig);
    let _redirectTo = configData?.redirectUrl || redirectUrl;
    const payload = {
      origin: window.location.origin,
      redirectUri: window.location.pathname,
    };
    const token = jwtEncode(payload, "");
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = `${_redirectTo}?referrer=${token}`;
  };

  checkOrRegisterUser = async (token) => {
    var _this = this;
    try {
      // let { data } = await axios.get(`${SERVER_IP}/findOrCreate/user`, {
      //   headers: {
      //     Authorization: `Bearer ${token}`,
      //   },
      // });

      // var bodyData = {
      //   email: data.data,
      //   logintype: "WebCredentails",
      //   devicetype: "WebBrowser",
      //   hardwaremodel: "chorme",
      //   hardwareos: "0",
      //   osversion: "0",
      //   applicationversion: "0",
      //   hardwareuniqueid: "khfksdkfhdskhfkdskhskjhfgkds",
      //   token: "sdkfhkdshgkshgkhfkg",
      //   longitude: 0,
      //   latitude: 0,
      //   ipaddress: "192.168.1.1",
      // };

      let response = await axios.post(`${SERVER_IP}/web/user/login`, {}, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      _this.setState({ loader: false });
      sessionStorage.clear();
      sessionStorage.setItem("jwt", `${response.data.JWT_token}`);
      sessionStorage.setItem("ud", `${JSON.stringify(response.data.userinfo)}`);
      sessionStorage.setItem("webgl_token", response.data.userinfo.webgl_token);
      return true;
    } catch (error) {
      console.log("error");
      console.log(error);
      // swal(error.response.data.message || error.message || "Please check your Email and Password.", "", "warning");
      // console.log(error);
      throw new Error("Something went wrong");
    }
  };

  getConfiguration = async (token) => {
    let _this = this;
    try {
      let { data } = await axios.get(`${UNO_URL}/api/application/configuration/${applicationId}`);
      let configuration = data?.data?.data || null;
      // configuration.API_URL = "https://localhost:3004";
      // configuration.UNO_URL = "https://localhost:3003";
      configuration && localStorage.setItem("configuration", JSON.stringify(configuration));
    } catch (error) {
      console.log(error);
    } finally {
      _this.getUserDetails(token);
    }
  };

  getUserDetails = async (userToken) => {
    let _this = this;
    try {
      if (!userToken) {
        _this.getAgainUnoUserToken();
      } else {
        if (!jwt) {
          await _this.checkOrRegisterUser(userToken);
          // _this.getLicenseDetails();
          window.location.href = "/";
        }
        _this.getUserDetailsFromUno(userToken);
      }

    } catch (error) {
      console.log(error);
      _this.getAgainUnoUserToken();
    } finally {
      // _this.getLicenseDetails();
      _this.setState({ loader: false });
    }
  };

  handleResize = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const isMobileView = isMobile(width, height);
    this.props.saveMobileView(isMobileView);
    if (isMobileView) {
      document.body.classList.add("mobile-view");
    } else {
      document.body.classList.remove("mobile-view");
    }
  };

  componentDidMount() {
    let _this = this;
    let token = "";
    const urlParams = new URLSearchParams(window.location.search);
    const _tokenParam = urlParams.get("referrer");

    if (_tokenParam) {
      const decoded = jwtDecode(_tokenParam);
      localStorage.setItem("unoToken", decoded.token);
      sessionStorage.setItem("unoToken", decoded.token);
      token = decoded.token;
    } else if (localStorage.getItem("unoToken")) {
      token = localStorage.getItem("unoToken");
    }

    _this.getConfiguration(token);
    this.handleResize();
    window.addEventListener("resize", this.handleResize);

    // _this.setState({loader: false});
    // _this.getLicenseDetails();
  }

  authanticate = () => {
    var req_data = {};
    let _this = this;
    axios
      .post(`${SERVER_IP}/reauthenticate`, req_data, { withCredentials: true })
      .then(function (response) {
        if (response.data.error == false) {
          changeUserInfo(response.data.JWT_token, response.data.details);
          window.location.href = "/";
        } else {
          _this.setState({ auth_wait: false });
          let localName = localStorage.getItem("light_DarkMode");
          sessionStorage.clear();
          localStorage.clear();
          localStorage.setItem("light_DarkMode", localName);
          if (!["/login", "/simulanislogin", "/", "/buynow"].includes(window.location.pathname)) {
            window.location.href = "/login";
          }
          // if (window.location.pathname != "/login") {
          //   if (window.location.pathname != "/simulanislogin") {
          //     window.location.href = '/login'
          //   }
          // }

          // DO Nothing
        }
      })
      .catch(function (error) {
        _this.setState({ auth_wait: false });
      });
  };

  toCalling = (to_calling_obj) => {
    this.setState({ to_calling_obj: to_calling_obj });
  };

  //Date Format 2022-07-27
  formatDate = (date) => {
    let d = new Date(date);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear();
    if (month.length < 2) {
      month = "0" + month;
    }
    if (day.length < 2) {
      day = "0" + day;
    }
    return [year, month, day].join("-");
  };

  emit_I_AM_ONLINE = () => {
    var json_data = {
      user_id: ud.id,
      session_id: ud.session_id,
      receive_data: true,
      datetime: this.formatDate(new Date()) + " " + new Date().toLocaleTimeString(),
    };
    socket.emit("i_am_online", json_data);
  };

  render() {
    const { user } = this.props;
    const { isMobile, userDetails } = user;
    let permissionList = userDetails?.user?.permissions || [];

    return this.state.loader ? (
      <FullScreenLoader loading={this.state.loader} />
    ) : (
      <UserState>
        {window.location.href != `${process.env.REACT_APP_LIVE_URL}videocall` &&
          window.location.href != `${process.env.REACT_APP_LIVE_URL}annotation` && (
            <div className="xp-vertical">
              <div id="xp-container">
                {this.state.auth_wait ? (
                  // <Authloading />
                  ""
                ) : (
                  <>
                    <Router>
                      {isMobile && false ? (
                        <>
                          {/* <HeaderMobile/> */}
                          <BottomNavigationBar />
                          {this.state.callChannel && jwt && ud && ud.usertype === 3 && (
                            <CallingChannel socket={socket} to_calling_obj={this.state.to_calling_obj} />
                          )}

                          <AppRoutes socket={socket} toCalling={this.toCalling} liveusers={this.state.liveusers} />
                        </>
                      ) : (
                        <>
                          {jwt && <Sidebar socket={socket} toCalling={this.toCalling} />}

                          <div class="xp-rightbar">
                            {jwt && <TopNavBar />}

                            {this.state.callChannel && jwt && ud && ud.usertype === 3 && (
                              <CallingChannel socket={socket} to_calling_obj={this.state.to_calling_obj} />
                            )}
                            {<Wrapper>
                              <AppRoutes socket={socket} toCalling={this.toCalling} liveusers={this.state.liveusers} />
                            </Wrapper>}

                          </div>
                        </>
                      )}
                    </Router>
                  </>
                )}
              </div>
            </div>
          )}
      </UserState>
    );
  }
}

const mapDispatchToProps = {
  saveMobileView,
  saveUserDetails,
  saveSubGroups,
};
const mapStateToProps = (state) => ({
  user: state.userData,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);


const Wrapper = ({ children }) => {
  const [showCallScreen, setShowCallScreen] = useState(false);
  const location = useLocation();
  const { userDetails } = useSelector((state) => state?.userData);
  const UNO_TOKEN = userDetails?.token;
  useEffect(() => {
    setShowCallScreen(location.pathname === "/");
  }, [location.pathname]);
  if (!UNO_TOKEN) return null;
  return (
    <>
      <div className={showCallScreen ? "d-block" : "d-none"}>
        <NewCall />
      </div>
      {children}
    </>
  );
};
